/**
 * Created by Miguel on 23/05/2017
 */
import { Component, OnInit  } from '@angular/core';
import { AppDataService }  from '../../../services/app-data.service';
import { CompanyService }  from '../../../services/company.service';
import {RecipeBean} from "../../../beansts/recipe.bean"
import {ItemBean} from "../../../beansts/item.bean"

import {WalletService} from "../../../services/wallet.services";
import { resetFakeAsyncZone } from '@angular/core/testing';
declare var $ : any;
declare var Swal: any

@Component({
    selector : 'craft-menu-modal',
    templateUrl:'craft-menu-modal.html',
})
export class CraftModal implements OnInit {
  public list;
  public containerList;
  public container=null;
  public ground=false;
  public groundList;
  public skills;
  public groundName='Chão';

  public containerName='Container';
  public title='Clique para usar'

    public ngOnInit() : any {
    }

    public clickContainerItem(item){
       //take item out of inventory to the container

      let itemToRemove=item.quantity;
      this._companyService.removeFromContainer(this.container,item).then(val=>{
        if (itemToRemove==1){
          this.containerList=this.containerList.filter((it)=>{
            return (item.id!=it.id)
          }) 
        }
/*        else{
          for (let i=0;i<this.containerList.length;i++){
            if (this.containerList[i].id==item.id){
              this.containerList[i].quantity=this.containerList[i].quantity-1;
            }
          }

        }*/
      })
      let citem=this.list.filter(it=>{
        return (it.id==item.id)
      })

      let itemToAdd=JSON.parse(JSON.stringify(item));
      if (citem.length>0){
        itemToAdd=citem[0]
        itemToAdd.quantity=itemToAdd.quantity+1;
      } else{
        itemToAdd.quantity=1;
      }
      this._companyService.addToUserContainer(this._appData.instagramUser,itemToAdd).then(val=>{
        if (itemToAdd.quantity==1){
          this.list.unshift(itemToAdd)
        }
/*        else{
          for (let i=0;i<this.list.length;i++){
            if (this.list[i].id==item.id){
              this.list[i].quantity=this.list[i].quantity+1;
            }
          }

        }*/
      })
      
    }
    public changeSkill(recipe){
      Swal.fire({
        title:recipe.name,
        text:'Você quer criar uma nova imagem para essa receita? Você será enviado para o site de edição.',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        showLoaderOnConfirm: true,
        preConfirm: (login) => {
          if (!login){
          }
          else{
            let domain=window.location.origin
            window.open(domain+"/draw?event="+this._appData.event.id+"&recipe="+recipe.id,'_blank');

          }
        }
      })

    }
    public clickItem(recipe){
      Swal.fire({
        title:recipe.name,
        text:'Tem certeza que deseja fabricar?',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        showLoaderOnConfirm: true,
        preConfirm: (login) => {
          if (!login){
            Swal.fire('Erro..','Selecione um numero maior que zero')
          }
          else{
            let baseRecipe=new RecipeBean();
            baseRecipe.parse(recipe)
            let baseItem =baseRecipe.toItem();
            let item=baseItem.toDB();

            this._appData.stream=recipe.video;
            $('#youtubeReload').click();
            this.sendIframeMessage({
              kind:'updateUserStatus',
              params:{walking:false,uid:this._appData.instagramUser.uid,state:'fight'}
            });
            this._walletService.updateUserSkill(recipe)

            setTimeout(()=>{
              this._appData.stream='';
              $('#youtubeReload').click();
              this.sendIframeMessage({
                kind:'updateUserStatus',
                params:{walking:false,uid:this._appData.instagramUser.uid,state:'stop'}
              }); 
            },recipe.timeInSeconds*1000)

          }
      }
    })

/*      let requirements='';
      let reqs={}
      if (item.requisite.length>0){
        requirements='Para produzir esse item você usará: ';
        item.requisite.forEach(req=>{
          requirements=requirements+req.name+' na quantidade:'+req.quantity+', '
          reqs[req.id]=req.quantity;
        }); 
      }

      let canWork=true;
      Swal.fire({
        title:'Produzir '+item.name,
        showCloseButton: true,
        text: requirements+" Você deseja tentar fabricar este item?",
        confirmButtonText: "Sim",
        preConfirm: () => {
          if (item.requisite){
            if (this._appData.userEventContainer){
              item.requisite.forEach(val=>{
                let reqId=val.id;
                let item=this._appData.userEventContainer.filter(it=>{
                  return it.id==reqId;
                })
                if (!item || item.length==0){
                  Swal.fire({title:'Falta requisito',text:'Você precisa de '+requirements+' para realizar essa tarefa'})
                  canWork=false;
                  return;
                }
                else if (item[0] && item[0].quantity<reqs[reqId]){
                  Swal.fire({title:'Falta requisito',text:'Você precisa de '+requirements+' para realizar essa tarefa'})
                  canWork=false;
                  return;
                }

              })
            }
            else{
              Swal.fire({title:'Falta requisito',text:'Você precisa de '+requirements+' para realizar essa tarefa'})
              canWork=false;
              return;
            }
          }
        
          if (canWork){
            this._appData.object=item;
            
            this._appData.param={link:item.video,name:'Usando o talento '+item.skill.name+' para obter '+item.name}
            $('#craftMenuModal').modal('hide');

            $('#externalLinkModal').modal("show");
            $('#externalLinkModalClick').click();
  
          }
        
      }});
*/
    }


    public change() {
      this.list=[]
      let param=this._appData.param;
      let skill=param.skill.id;
      this.title=skill.name;
      if (!this._appData.eventRecipes || this._appData.eventRecipes.length==0){
        this._companyService.getRecipesRef(this._appData.event).where('skillId',"==",skill).get().then(val=>{
          let allRecipes=[]
          val.forEach(v=>{
            let recipe=new RecipeBean();
            recipe.parse(v.data());
            allRecipes.push(recipe)
            if (recipe.kind=="craft"){
              this.list.push(recipe)
            }
          });
          this._appData.eventRecipes=allRecipes;
        }); 
      }
      else{
        this._appData.eventRecipes.forEach(recipe=>{
          if (recipe.kind=="craft" && recipe.skillId==skill){
            this.list.push(recipe)
          }
        })
      }

      this._companyService.getUserContainer(true)
      if (!this._appData.userEventSkills){
        this._companyService.getUserSkills()
      }
    }
    constructor( public _appData : AppDataService,private _companyService : CompanyService, public _walletService: WalletService) {
    }


    public sendIframeMessage(messageKind){
      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage(messageKind, "*");
    }

}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/craft-menu/craft-menu-modal.ts